/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ContactMethodMarketing/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function ContactMethodMarketing({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ContactInput/ContactMethodMarketing",
  onChange
  
}) {
  let isMedia = useIsMedia()
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let contactDetailsSelectedAllowmarketingValueData = fromData.useDataValue({ viewPath,
context: 'contactDetails',
path: 'selected.allowMarketing',
})
let contactDetailsSelectedAllowmarketingChangeData = fromData.useDataChange({ viewPath,
context: 'contactDetails',
path: 'selected.allowMarketing',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtCheckboxStrokeBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.stroke.brand.selected'
        })
let dtCheckboxBackgroundcolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.backgroundColor.brand.selected'
        })
let dtCheckboxBordercolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.borderColor.brand.selected'
        })
let dtCheckboxBordercolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.borderColor.brand.hovered'
        })
let widgetSettingsMarketingoptinValueData = fromData.useDataFormat({ viewPath,
context: 'widget',
path: 'settings.marketingOptin',
format: fromHelpers.getText,
})
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let contactDetailsSelectedAllowmarketingmethodsValueData = fromData.useDataValue({ viewPath,
context: 'contactDetails',
path: 'selected.allowMarketingMethods',
})
let contactDetailsSelectedAllowmarketingmethodsChangeData = fromData.useDataChange({ viewPath,
context: 'contactDetails',
path: 'selected.allowMarketingMethods',
})
  return (<React.Fragment
>
<div
  data-testid="ContactMethodMarketing.Horizontal"
  data-view-path={viewPath}
 style={{'--jc-1-ZKhbzu': isMedia.mobile ? "space-evenly" : "space-between",'--mb-2-ZKhbzu': isMedia.mobile ? typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS : "0px"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="ContactMethodMarketing.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 marginBottom={dtSpaceXs}
 marginTop={dtSpaceS}
 marginRight={dtSpaceS}
 data="contactDetails.selected.allowMarketing"
 value={contactDetailsSelectedAllowmarketingValueData}
 onChange={contactDetailsSelectedAllowmarketingChangeData}
 strokeSelected={dtCheckboxStrokeBrandSelected}
 backgroundColorSelected={dtCheckboxBackgroundcolorBrandSelected}
 borderColorSelected={dtCheckboxBordercolorBrandSelected}
 borderColorHovered={dtCheckboxBordercolorBrandHovered}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 marginLeft={dtSpaceS}
 data="widget.settings.marketingOptin"
 format="./helpers.js getText"
 text={widgetSettingsMarketingoptinValueData}
/>
</React.Fragment>
)}
</TysiaCheckbox>
</div>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 allowEmptyChoice={false}
 marginRight={dtSpaceXs}
 maxWidth={160}
 data="options"
 from={optionsValueData}
 data="contactDetails.selected.allowMarketingMethods"
 value={contactDetailsSelectedAllowmarketingmethodsValueData}
 onChange={contactDetailsSelectedAllowmarketingmethodsChangeData}
>
{childProps => (
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
)}
</TysiaSelectOne>
</div>
{children}
</React.Fragment>)
}